module.exports = __webpack_public_path__ + "static/media/upload.b7486d94.svg";